<template>
  <v-form
    id="PersonalDetails"
    v-model="valid"
  >
    <h2 class="header">
      Personal Details
    </h2>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <snackbar-component
          :options="snackbar"
          @close-snackbar="closeSnackbar()"
        />
        <v-text-field
          v-model="candidate.first_name"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="First Name*"
          filled
          :rules="[...Rules.required, ...Rules.name]"
          :error-messages="pgError.personal.postCode"
          @keyup="resetErrorMessage('fistName')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-text-field
          v-model="candidate.other_name"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Other Name"
          :rules="Rules.alphaDash"
          filled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-text-field
          v-model="candidate.last_name"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Last Name*"
          filled
          :rules="[...Rules.required, ...Rules.name]"
          :error-messages="pgError.personal.lastName"
          @keyup="resetErrorMessage('lastName')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-select
          v-model="candidate.gender"
          :disabled="candidate.is_synced === 1"
          class="textField"
          :items="genders"
          item-text="text"
          item-value="value"
          filled
          label="Gender*"
          :rules="Rules.required"
          @change="changeGenderIdentifier( $event, 'gender')"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-select
          v-model="candidate.candidate_details.identifies_as"
          class="textField"
          :items="genderIdentifier"
          item-text="text"
          item-value="value"
          filled
          label="Identifies As"
          @change="changeGenderIdentifier( $event, 'genderIdentifier')"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-dialog
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          width="320px"
          attach
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="computedDateFormatted"
              :disabled="candidate.is_synced === 1"
              label="Date Of Birth (Please click to select)*"
              class="textField"
              :rules="[...Rules.required, ...Rules.beforeOrEqualDate(candidate.date_of_birth, minimumDate)]"
              readonly
              filled
              v-on="on"
            />
          </template>
          <v-sheet>
            <h3 class="picker-heading">
              Select your DOB
            </h3>
            <small class="picker-subheading">you must be at least 16 years old to register</small>
            <v-date-picker
              ref="dobPicker"
              v-model="candidate.date_of_birth"
              color="agency-color-primary"
              :max="minimumDate.toISOString().substr(0, 10)"
              min="1900-01-01"
              width="320px"
              no-title
              @change="$refs.menu.save(date)"
            />
          </v-sheet>
        </v-dialog>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <div class="d-flex align-start">
          <v-text-field
            v-model="candidate.candidate_details.ni_number"
            :disabled="candidate.is_synced === 1"
            :readonly="tempNiNumber"
            class="textField"
            label="NI Number*"
            filled
            :rules="[...Rules.ni_number, ...Rules.required]"
            counter="9"
            :error-messages="pgError.personal.niNumber"
            @keyup="resetErrorMessage('niNumber')"
          />
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="!candidate.candidate_details.ni_number"
    >
      <v-col class="niContainer">
        <input
          id="txtNiNumber"
          ref="theCheckbox"
          v-model="tempNiNumber"
          style="width: 25px; height: 25px; vertical-align: middle;"
          type="checkbox"
          @change="checkTempNiRequirement()"
        > Generate Temporary NI Number.
      </v-col>
      <v-col />
      <v-col />
    </v-row>
    <v-btn
      tile
      outlined
      color="agency-color-secondary"
      @click="loginBack ()"
    >
      Back to login
    </v-btn>
    <v-btn
      :disabled="!valid"
      tile
      dark
      color="agency-color-primary"
      @click="next()"
    >
      Next
    </v-btn>
  </v-form>
</template>
<script>
export default {
  name: 'PersonalDetails',
  props: {
    candidate: {
      type: Object,
      default: () => {
        return {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    },
    pgError: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    snackbar: {
      show: false,
      message: '',
      type: 'success'
    },
    tempNiNumber: false,
    valid: false,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    genders: [
      {
        text: 'Male',
        value: 'M'
      },
      {
        text: 'Female',
        value: 'F'
      }
    ],
    genderIdentifier: [
      {
        text: 'Male',
        value: 'M'
      },
      {
        text: 'Female',
        value: 'F'
      },
      {
        text: 'Non-binary',
        value: 'N'
      }
    ]

  }),
  computed: {
    minimumDate () {
      const minDate = new Date()
      minDate.setFullYear(minDate.getFullYear() - 16)
      return minDate
    },
    computedDateFormatted () {
      return this.formatDate(this.candidate.date_of_birth)
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.dobPicker.activePicker = 'YEAR'))
    }
  },
  methods: {
    closeSnackbar () {
      this.snackbar.show = false
    },
    changeGenderIdentifier ($event, obj) {
      if (obj === 'gender' && this.candidate.candidate_details.identifies_as !== 'N') {
        this.candidate.candidate_details.identifies_as = this.candidate.gender
      } else if (obj === 'genderIdentifier' &&
          this.candidate.candidate_details.identifies_as !== 'N' &&
          !this.candidate.gender
      ) {
        this.candidate.gender = this.candidate_details.candidate.identifies_as
      }
    },
    next () {
      this.$emit('next', {
        newCandidate: this.candidate
      })
      localStorage.setItem('candidate_register', JSON.stringify(this.candidate))
    },
    checkTempNiRequirement () {
      if (this.$refs.theCheckbox.checked && this.candidate.gender && this.candidate.date_of_birth) {
        const [fullYear, month, day] = this.candidate.date_of_birth.substr(0, 10).split('-')
        const year = fullYear.substr(2, 3)
        this.candidate.candidate_details.ni_number = 'TN' +
            day.toString() +
            month.toString() +
            year.toString() +
        this.candidate.gender
      } else if (this.$refs.theCheckbox.checked) {
        document.getElementById('txtNiNumber').checked = false
        this.tempNiNumber = false
        this.snackbar.message = ' Please enter your Gender and Birthdate to generate temporary Ni Number.'
        this.snackbar.type = 'error'
        this.snackbar.show = true
      } else {
        this.candidate.candidate_details.ni_number = ''
      }
    },
    loginBack () {
      this.$emit('loginBack')
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}`
    },
    resetErrorMessage (field) {
      switch (field) {
        case 'firstName':
          this.pgError.personal.firstName = ''
          break
        case 'lastName':
          this.pgError.personal.lastName = ''
          break
        case 'niNumber':
          this.pgError.personal.niNumber = ''
          break
      }
    }
  }
}
</script>
<style lang='scss'>
@import './resources/sass/variables';
#PersonalDetails {
  .picker-heading {
    display: flex;
    justify-content: center;
    margin: 0;
    padding-top: 6px;
    color: white;
    background-color: $agencyColorPrimary;
    font-size: 28px;
    font-weight: 500;
  }
  .picker-subheading {
    display: flex;
    justify-content: center;
    margin: 0;
    padding-bottom: 6px;
    color: white;
    background-color: $agencyColorPrimary;
    font-family: "Nunito", sans-serif;
  }
    .niContainer{
        margin-bottom: 20px;
        margin-left: 20px;
    }
}
</style>
